module.exports = __webpack_public_path__ + "static/person-bubble-1-865f8a5acaebfe3bc5ec119b5bd37258.png";